import { defineStore } from 'pinia'

import { StoreId } from '@/store'

import { Success } from '@/api/results'
import type {
  BasketPayment,
  BasketPayments,
} from '@/types/api/api-v3/paymentMethods'
import { PaymentMethodType } from '@/types/api/api-v3/paymentMethods'
import type { LoadState } from '@/types/main'
/* Types */
import type { PaymentMethodState } from '@/types/store/basket/paymentMethods'

const defaultState: PaymentMethodState = {
  data: [],
  isLoading: false,
  isLoaded: false,
  error: null,
}

export const state = () => defaultState

export const useBasketPaymentMethodsStore = defineStore({
  id: StoreId.BASKET_PAYMENT_METHODS,
  state: (): PaymentMethodState => defaultState,
  actions: {
    async getPaymentMethods() {
      this.setPaymentMethods({ isLoading: true })

      const { $apiService } = useNuxtApp()
      const { isMobile } = useDevice()

      const result = await $apiService.basket.getPaymentMethods(isMobile)

      if (!(result instanceof Success)) {
        this.setPaymentMethods({
          isLoaded: true,
          error: result,
          isLoading: false,
        })

        return
      }

      const basketPayments = this.getFormattedBasketPayments(result.data)

      this.setPaymentMethods({
        isLoaded: true,
        data: basketPayments,
        error: null,
        isLoading: false,
      })
    },

    getFormattedBasketPayments(
      basketPayments: BasketPayments,
    ): BasketPayment[] {
      const paymentsMethods: BasketPayment[] = [
        ...basketPayments.payment_methods,
      ]

      /*
        Ищем index позиции для сохран. карт,
        после чего выполняем вставку с удалением элемента по index
      */
      const indexPositionSavedCard = paymentsMethods.findIndex(
        (payment) => payment.type === PaymentMethodType.FEATURE_SAVED_CARD,
      )

      // Если index фичи карты нет, то возвращаем простой список оплат
      if (indexPositionSavedCard === -1) return paymentsMethods

      const { pay_selection_cards } = basketPayments

      paymentsMethods.splice(indexPositionSavedCard, 1, ...pay_selection_cards)

      return paymentsMethods
    },

    setPaymentMethods(paymentMethods: Partial<LoadState<BasketPayment[]>>) {
      Object.assign(this.$state, paymentMethods)
    },
  },
})
